import React from 'react';
import { Button } from 'semantic-ui-react';

export default ({ history }) => (
  <Button
    circular
    onClick={() => {
      history.push('/login');
    }}
  >
    เข้าสู่ระบบ
  </Button>
);
